import { render, staticRenderFns } from "./send-coupon.vue?vue&type=template&id=97c737e8&scoped=true"
import script from "./send-coupon.vue?vue&type=script&lang=js"
export * from "./send-coupon.vue?vue&type=script&lang=js"
import style0 from "./send-coupon.vue?vue&type=style&index=0&id=97c737e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c737e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97c737e8')) {
      api.createRecord('97c737e8', component.options)
    } else {
      api.reload('97c737e8', component.options)
    }
    module.hot.accept("./send-coupon.vue?vue&type=template&id=97c737e8&scoped=true", function () {
      api.rerender('97c737e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/activities/send-coupon.vue"
export default component.exports